import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function ArticleCardGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-3">
            Poradniki i artykuły Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dowiedz się więcej o bezpiecznych zakupach, wysyłce do Polski i najlepszych produktach. Praktyczne porady od ekspertów.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-primary-300 transition-all duration-200"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 right-3 bg-background-50/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs text-foreground-600 flex items-center gap-1">
                  <i className="ri-time-line text-[10px]"></i>
                  {article.readTime}
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                  Czytaj więcej
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}